import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollBankExport  {
    _originalTypeClassName = "zERP.BO.PayrollBankExport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollBankExport.translate = translateService;
}
this.Details = [];
this.Id = null;
this.Name = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Payroll:any;
Details:any;
static setPayroll = ($this, value) => {
var oldValue = $this.Payroll;
$this.Payroll = value;
if (value != null) {
if (oldValue != null && oldValue.BankExportFile != null) { oldValue.BankExportFile = null; }
if ($this.Payroll.BankExportFile !== $this) {
Domain.Payroll.setBankExportFile(value, $this);
}
}
}
static setDetails = ($this, items) => {
                if (items == null) items = [];
                if ($this.Details == null) $this.Details = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Details.length > 0) {
                    Domain.PayrollBankExport.removeDetails($this, $this.Details[0]);
                }

                Domain.PayrollBankExport.addManyDetails($this, copyItems);
            }
static addManyDetails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PayrollBankExport.addDetails($this, items[i]);
                }
            }
static addDetails = ($this, item) => {
                if ($this.Details == null) $this.Details = [];
                if (item == null || $this.Details.indexOf(item) > -1) return;
                $this.Details.push(item);
if (item.BankExport != $this) {
Domain.PayrollBankExportDetail.setBankExport(item, $this);
}
}
static addRangeDetails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PayrollBankExport.addDetails($this, item));
            }
static removeDetails = ($this, item) => {
                if ($this == null || $this.Details == null || $this.Details.indexOf(item) === -1) return;
                var _index = $this.Details.indexOf(item);
                $this.Details.splice(_index, 1);
item.BankExport = null;
}
static clearDetails = ($this) => { $this.Details = null; }

static GetEmployees(bankExport: any,advanceDate: any,issueDate: any,isAdvance: any): any{let RetrievedEmployees = [];
let dateToCheck = (isAdvance ? advanceDate : issueDate);
for (let _icalculation = 0; _icalculation < (bankExport?.Payroll?.Calculations == null ? 0 : bankExport?.Payroll?.Calculations.length); _icalculation++) {let calculation = bankExport?.Payroll?.Calculations[_icalculation];for (let _iempPay = 0; _iempPay < (calculation?.Employees == null ? 0 : calculation?.Employees.length); _iempPay++) {let empPay = calculation?.Employees[_iempPay];if (!(RetrievedEmployees?.linq?.any((a) => CLMS.Framework.Number.Equal(() => a.Id, () => empPay.Employee.Id)))) {RetrievedEmployees?.add(empPay?.Employee);}}}
if (bankExport?.Details == null || CLMS.Framework.Number.Equal(() => bankExport.Details.length, () => 0) || !(bankExport?.Details?.linq?.any((l) => (new Date(l?.PaymentDate).getTime()) == (new Date(dateToCheck).getTime())))) {return RetrievedEmployees;}
let ExcludedEmployees = [];
let AlreadyCreatedDetails = bankExport?.Details?.linq?.where((l) => (new Date(l?.PaymentDate).getTime()) == (new Date(dateToCheck).getTime()))?.toArray();
for (let _idet = 0; _idet < (AlreadyCreatedDetails == null ? 0 : AlreadyCreatedDetails.length); _idet++) {let det = AlreadyCreatedDetails[_idet];for (let _iempPay = 0; _iempPay < (det?.Employees == null ? 0 : det?.Employees.length); _iempPay++) {let empPay = det?.Employees[_iempPay];if (!(ExcludedEmployees?.linq?.any((a) => CLMS.Framework.Number.Equal(() => a.Id, () => empPay.Employee.Id)))) {ExcludedEmployees?.add(empPay?.Employee);}}}
console.info("--BEFORE-- RetrievedEmployees.Length: " + Joove.Common.safeNumber(RetrievedEmployees?.length));
RetrievedEmployees = Joove.Common.cast(RetrievedEmployees?.linq?.except(ExcludedEmployees)?.toArray(), "System.Collections.List");
console.info("--AFTER-- RetrievedEmployees.Length: " + Joove.Common.safeNumber(RetrievedEmployees?.length));
return RetrievedEmployees;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}